export enum ConnectorServiceEnum {
  AzureActiveDirectory = 'azure-active-directory',
  AzureOidc = 'azure-oidc',
  AzureSaml = 'azure-saml',
  BambooHR = 'bamboohr',
  Bring = 'bring',
  CatalystOne = 'catalyst-one',
  Deel = 'deel',
  Dustin = 'dustin',
  Fedex = 'fedex',
  GithubOidc = 'github-oidc',
  GoogleDevices = 'google-devices',
  GoogleOidc = 'google-oidc',
  GoogleSaml = 'google-saml',
  GoogleWorkspace = 'google-workspace',
  HaileyHR = 'haileyhr',
  Hexnode = 'hexnode',
  Hibob = 'hibob',
  Ingram = 'ingram',
  Inrego = 'inrego',
  Jamf = 'jamf',
  Kandji = 'kandji',
  MicrosoftIntune = 'microsoft-intune',
  Netset = 'netset',
  Posti = 'posti',
  Postnord = 'postnord',
  ServiceNow = 'service-now',
  Teamtailor = 'teamtailor',
  Velory = 'velory',
  Webmercs = 'webmercs',
}
